<template>
  <div>
    <b-alert 
      v-for="(item, index) in itemList" 
      :key="index" show 
      :variant="getVariantCard(item.action)" 
      class="my-2 p-1"
    >

      <div class="d-flex justify-content-end align-items-center">
        <span class="text-muted mr-1">{{ item.action.toUpperCase() }}</span>
        <b-button 
          :variant="showCardComplete.includes(index) ? 'info' : ''" 
          size="sm" 
          @click="onViewItem(index)"
        >
          <i class="fa-solid fa-magnifying-glass"/>
        </b-button>

        <b-button 
          v-if="item.action !== 'eliminar'"
          variant="danger" 
          size="sm"
          class="ml-1"
          @click="onRemoveItemList(index)"
        >
          <i class="fa-solid fa-x"/>
        </b-button>

        <b-button 
          v-if="item.action === 'eliminar'"
          variant="warning" 
          size="sm"
          class="ml-1"
          @click="onRestoreItem(index)"
          title="Restaurar Item"
        >
          <i class="fa-solid fa-rotate-right"/>
        </b-button>
      </div>

      <h1>hello</h1>

      <!-- <b-row class="d-flex align-items-center mb-1">
        <strong class="col-3">Fecha y Hora: </strong> 
        <span class="text-white col">{{ item.fecha }} / {{ item.hora }}</span>
      </b-row>

      <b-row class="d-flex align-items-center mb-1">
        <strong class="col-3">Profesional: </strong> 
        <span class="text-white col">{{ getProfesional(item) }}</span> <br/>
      </b-row>

      <span v-if="showCardComplete.includes(index)">
        <b-row  class="d-flex align-items-center mb-1">
          <strong class="col-3">Notas de Evolucion: </strong> 
          <span class="text-white col">{{ item.notas }}</span> <br/>
        </b-row>

        <b-row class="d-flex align-items-center mb-1">
          <strong class="col-3">Farmacoterapia e Indicaciones:: </strong> 
          <span class="text-white col">{{ item.farmacoterapia }}</span> <br/>
        </b-row>

        <b-row class="d-flex align-items-center">
          <strong class="col-3">Dispositivo: </strong> 
          <span class="text-white col">{{ item.dispositivo }}</span>
        </b-row>
      </span> -->
        
    </b-alert>
  </div>
  
</template>

<script>
export default {

  name: 'CardList',

  props:{

    itemList:{
      type: Array,
      default : () => []
    },

    fieldsToShow:{
      type: Array,
      default : () => []
    }
  },


  data(){
    return{

      showCardComplete: [],

    }
  },


  methods:{

    onViewItem(index) {
      const exists = this.showCardComplete.includes(index)

      this.showCardComplete = exists 
        ? this.showCardComplete.filter(item => item !== index)
        : [...this.showCardComplete, index];
    },


    async onRemoveItemList(index){

      const result = await this.$swal.fire({
        title: 'Eliminar Item Examen',
        text: "Estas seguro de eliminar este examen?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      if (this.itemList[index].action === 'registrado'){
        this.itemList[index].action = 'eliminar';
        return;
      }

      this.itemsTabla.splice(index, 1)
    },

    onRestoreItem(index){
      this.itemList[index].action = 'registrado'
    },


    getVariantCard(action){

      const variant = action === 'registrado' 
        ? 'success'
        : action === 'eliminar'
          ? 'danger'
          : 'info';

      return variant;
    },

  }
}
</script>

<style>

</style>